module.exports = __webpack_public_path__ + "img/zubg.95327f50.png";